module.exports = __webpack_public_path__ + "static/media/profile-placeholder.fffc1883.svg";